import { inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/shared/Auth/auth.service';
import { RoutePermissionService } from '../services/shared/route-permission.service';
import { filter, map, take } from 'rxjs';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  const routePermissionService = inject(RoutePermissionService);

  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  if (!authService.isLoggedIn()) {
    router.navigateByUrl('/auth');
    return false;
  }

  if (state.url === '/') {
    return true;
  }

  return authService.userData$.pipe(
    filter((user) => user !== null),
    take(1),
    map((user) => {
      const userPermissions = routePermissionService.getUserPermissions();

      if (!user?.menu?.length || !userPermissions.length) {
        router.navigateByUrl('/forbidden');
        return false;
      }

      const currentUrl = state.url.split('?')[0].split('#')[0];

      if (currentUrl === '/dashboard' || currentUrl === '/') {
        return true;
      }

      const requiredPermission = routePermissionService.getRequiredPermission(currentUrl, user.menu);

      if (!requiredPermission) {
        router.navigateByUrl('/forbidden');
        return false;
      }

      if (routePermissionService.hasPermission(requiredPermission)) {
        return true;
      }

      router.navigateByUrl('/forbidden');
      return false;
    })
  );
};
